import style from "./style.module.css";
import BaseApi from "../../../services/Api";
import React, { useEffect } from "react";
import { toast } from "react-toastify";
import helpingHand from "../../../images/frontDonations/icon _Helping Hands.svg";
import affiliate from "../../../images/frontDonations/icon _affiliate.svg";
import calendar from "../../../images/frontDonations/icon _Calendar tools.svg";
import donationBox from "../../../images/frontDonations/icon _donation box_.svg";
import handDolar from "../../../images/frontDonations/icon _Hand Holding US Dollar_.svg";
import partners from "../../../images/frontDonations/icon _partners.svg";
import {register} from 'swiper/element/bundle';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

register();

const INITIAL_DATA = {
    total: 0,
    current_page: 1,
    last_page: 1,
    first_page_url: "",
    last_page_url: "",
    next_page_url: "",
    prev_page_url: null,
    path: "",
    from: 1,
    to: 1,
    data: [],
};  

export default function Donations(props)
{

    return (


        <>
        <div className={style.rectangle}>
        <Swiper
            slidesPerView={1}
            pagination={{clickable: true}}
            navigation
            loop = {true}
            className={style.swiperEdit}
        >
            {props.donationsData.map((item) =>
            (
                <SwiperSlide key={item.id} className="mt-auto mb-auto mx-auto">
                    <div className={style.organization}>
                        <div className={style.masking}>
                            <img src={item.icon} alt="icon" className={style.img} />
                        </div>
                        <div className={style.text}>
                            <div className="d-flex flex-column">
                                <span className={style.title}>{item.name}</span>
                                <span className={style.description}>{item.description}</span>
                                <span className={style.adicionalInformations}>{item.moreInfo}</span>
                            </div>
                        </div>
                    </div>
                </SwiperSlide> 
            )
            )}
        </Swiper>
        </div>
        <div className="mb-5">
            <span className={style.helpTitle}>OUTRAS FORMAS DE AJUDA</span>
            <div>
                <div className={style.spacing}>
                    <div>
                        <div className={style.subtitleOrganization}>

                            <span className={style.subtitle}><img src={helpingHand} className={style.helpIcon} alt="helping hand" />Voluntariado</span>
                        </div>
                        <div>
                            <p className={style.helpDescription}>
                                Breve descrição - Breve descrição - Breve descrição - Breve descrição -Breve descrição - Breve descrição -Breve descrição
                            </p>
                        </div>
                    </div>
                    <div>
                        <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSfwPdq4tJWOeJdzm48IGODH0IkJFYMaTMvCTBxrOlBLGvpwIA/viewform?usp=sf_link" className={style.button}>EU QUERO</a>
                    </div>
                </div>
                <div className={style.spacing}>
                    <div>
                        <div className={style.subtitleOrganization}>

                            <span className={style.subtitle}><img src={partners} className={style.helpIcon} alt="Sócios" /> Sócio VIPA</span>
                        </div>
                        <div>
                            <p className={style.helpDescription}>
                                Breve descrição - Breve descrição - Breve descrição - Breve descrição -Breve descrição - Breve descrição -Breve descrição
                            </p>
                        </div>
                    </div>
                    <div>
                        <a target = "_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSegFAK7TkJfw7jHvw-wwsdj3JHd1xSF2lNiQBrMbxjRGd9-1Q/viewform?usp=sf_link" className={style.button}>EU QUERO</a>
                    </div>
                </div>
                <div className={style.spacing}>
                    <div>
                        <div className={style.subtitleOrganization}>

                            <span className={style.subtitle}><img src={calendar} className={style.helpIcon} alt="calendario" /> Mantenedor</span>
                        </div>
                        <div>
                            <p className={style.helpDescription}>
                                Breve descrição - Breve descrição - Breve descrição - Breve descrição -Breve descrição - Breve descrição -Breve descrição
                            </p>
                        </div>
                    </div>
                    <div>
                        <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSeNSXsg1YQnXy2VJjM4Hny2ErbZh_OOYfKmq4zd5acFrAN0JQ/viewform" className={style.button}>EU QUERO</a>
                    </div>
                </div>
                <div className={style.spacing}>
                    <div>
                        <div className={style.subtitleOrganization}>

                            <span className={style.subtitle}><img src={affiliate} className={style.helpIcon} alt="Parceiro" /> Parceiro</span>
                        </div>
                        <div>
                            <p className={style.helpDescription}>
                                Breve descrição - Breve descrição - Breve descrição - Breve descrição -Breve descrição - Breve descrição -Breve descrição
                            </p>
                        </div>
                    </div>
                    <div>
                        <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSeNSXsg1YQnXy2VJjM4Hny2ErbZh_OOYfKmq4zd5acFrAN0JQ/viewform" className={style.button}>EU QUERO</a>
                    </div>
                </div>
                <div className={style.spacing}>
                    <div>
                        <div className={style.subtitleOrganization}>

                            <span className={style.subtitle}><img src={handDolar} className={style.helpIcon} alt="Mão segurando dinheiro" /> Doar itens para bazar ou pro vipa</span>
                        </div>
                        <div>
                            <p className={style.helpDescription}>
                                Breve descrição - Breve descrição - Breve descrição - Breve descrição -Breve descrição - Breve descrição -Breve descrição
                            </p>
                        </div>
                    </div>
                    <div>
                        <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSeOF2yvlV7OxvD1d9rF8d1LYk8_MRfm9eTPZJxNGLCSBsKqFg/viewform?usp=sf_link" className={style.button}>EU QUERO</a>
                    </div>
                </div>
                <div className={style.spacing}>
                    <div>
                        <div className={style.subtitleOrganization}>

                            <span className={style.subtitle}><img src={donationBox} className={style.helpIcon} alt="Caixa de doação" /> Doar ração ou material de limpeza</span>
                        </div>
                        <div>
                            <p className={style.helpDescription}>
                                Breve descrição - Breve descrição - Breve descrição - Breve descrição -Breve descrição - Breve descrição -Breve descrição
                            </p>
                        </div>
                    </div>
                    <div>
                        <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSeOF2yvlV7OxvD1d9rF8d1LYk8_MRfm9eTPZJxNGLCSBsKqFg/viewform" className={style.button}>EU QUERO</a>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}